module.exports = __webpack_public_path__ + "img/rhodium.8b05dbd.webp";